import { DesktopNavigation } from '@/domain/mitarbeiter/features/anlageassistent/components/NavigationWrapper';
import { DesktopFooter } from '@/domain/mitarbeiter/features/anlageassistent/components/Footer';

import { AnlageassistentProgressbar } from '@/domain/mitarbeiter/features/anlageassistent/components/Progressbar';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentContext';
import { Header } from '@/domain/mitarbeiter/features/anlageassistent/components/Header';
import { Content } from '@/domain/mitarbeiter/features/anlageassistent/components/Content';

export function DesktopPage() {
  const { ctx } = useAnlageassistentContext();
  const currentStep = ctx.state.steps[ctx.state.currentStepIndex];
  return (
    <div className="flex h-full">
      <DesktopNavigation />
      <div className="flex flex-col w-full">
        <div className="bg-neutrals-100 w-full flex justify-center h-full">
          {currentStep.type === 'step' ? (
            <div className="flex flex-col items-start gap-2 px-48 w-full pt-10">
              <Header />
              <AnlageassistentProgressbar />
              <Content />
            </div>
          ) : (
            <div className="flex flex-col w-full p-10">
              <Content />
            </div>
          )}
        </div>
        <DesktopFooter />
      </div>
    </div>
  );
}
